import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { take, finalize } from 'rxjs/operators';

import { StoreService } from '../../../stores/services/store.service';
import { FlashService } from '../flash/services/flash.service';

@Component({
  selector: 'app-dialog-import',
  templateUrl: './dialog-import.component.html',
  styleUrls: ['./dialog-import.component.sass']
})
export class DialogImportComponent implements OnInit {
  selectedFile: any = {};
  csvErrors = [];
  uploading = false;

  constructor(
    public dialogRef: MatDialogRef<DialogImportComponent>,
    public storeService: StoreService,
    private flashService: FlashService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
  }

  onCsvFileSelected(uploaded) {
    this.csvErrors = [];

    // const lines = parseCsv(uploaded.file.content, null);

    // lines.forEach((line, i) => {

    //   line[0] = line[0].replace(/ /g, '');

    //   if ( !line[0]
    //     || !line[1]
    //     || !line[0].trim().match(/^([0-9]{9}|[0-9]{14})$/)
    //   ) {
    //     this.csvErrors.push({
    //       line: i + 1,
    //       content: line.join(','),
    //     });
    //   }
    // });

    if (!this.csvErrors.length) {
      this.upload(uploaded);
    }
  }

  onStartAgain() {
    this.csvErrors = [];
  }

  onCancel() {
    this.dialogRef.close(false);
  }

  upload(file) {
    this.uploading = true;

    this.storeService.upload(file.raw)
      .pipe(
        take(1),
        finalize(() => {
          this.uploading = false;
        })
      )
      .subscribe(
        (response) => {
          this.csvErrors = [];

          Object.keys(response).forEach((siret, i) => {
            const line = response[siret];

            if (line.siret || line.name) {
              let error = '';

              if (line.siret) {
                error += line.siret.join(', ');
              }

              if (line.name) {
                if (error) {
                  error += ', ';
                }
                error += line.name.join(', ');
              }

              this.csvErrors.push({
                line: siret,
                content: error
              });
            }
          });

          if (!this.csvErrors.length) {
            this.flashService.success('stores.dialog.import.form.success');
            this.dialogRef.close(true);
          }
        },
        (error) => {
          alert('Import error ' + error.status);
        }
    );
  }
}
